/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteTomoquestionnaireId$Params {

/**
 * questionnaire ID
 */
  id: string;
  'api-version'?: string;
}

export function deleteTomoquestionnaireId(http: HttpClient, rootUrl: string, params: DeleteTomoquestionnaireId$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteTomoquestionnaireId.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteTomoquestionnaireId.PATH = '/tomoQuestionnaire/{id}';
